import { render, staticRenderFns } from "./CompetitionEdit.vue?vue&type=template&id=024ae109&scoped=true&"
import script from "./CompetitionEdit.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ae109",
  null
  
)

export default component.exports